import React, { useState, useEffect } from "react";
import LoadingSpinner from "../../composant_reutilisable/loading";
import { motion, AnimatePresence } from "framer-motion";
import { useMediaQuery } from "react-responsive";
import { FaBoxOpen, FaLayerGroup, FaShip, FaWeightHanging } from "react-icons/fa";
import { FaRoadBarrier } from "react-icons/fa6";
import { BsCarFront } from "react-icons/bs";
import { useLocation, useParams } from 'react-router-dom';

const Liste_nationaux = ({ titre }) => {
  const location = useLocation();
  // const { nom_parc } = location.state || {}; // Obtention de le refrence du parc
  const { parc_ref } = useParams();
  const [camions, setCamions] = useState([]);
  const [camionsSortants, setCamionsSortants] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isPaused, setIsPaused] = useState(false); // ⬅️ état pause pour stopper le defilement des écrans
  // const [isMobileView, setIsMobileView] = useState(false);

  // Carrousel states
  const [currentPageFIFO, setCurrentPageFIFO] = useState(0);
  const [currentPageSortants, setCurrentPageSortants] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [pageDuration, setPageDuration] = useState(5);

  // Paramètres dynamiques
  const nbParPageFIFO = itemsPerPage || 5;
  const nbParPageSortants = itemsPerPage || 5;
  const dureeAffichageFIFO = (pageDuration || 5) * 1000;
  const dureeAffichageSortants = (pageDuration || 5) * 1000;

  // Nombre total de pages
  const totalPagesFIFO = Math.ceil(camions.length / nbParPageFIFO) || 1;
  const totalPagesSortants =
    Math.ceil(camionsSortants.length / nbParPageSortants) || 1;


  const [parcs, setParcs] = useState([]);
  // Récupération de tous les parcs
  const fetchParcs = async () => {
    try {
      setIsLoading(true);
      const response = await fetch(process.env.REACT_APP_HOTE + "/liste-parc/");
      if (response.ok) {
        const data = await response.json();
        setParcs(data);
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des parcs:", error);
    } finally {
      setIsLoading(false);
    }
  };

  //Récupération de toutes les catégories
  const [selectedCategorie, setSelectedCategorie] = useState(null); // null = pas de filtre
  const [allCategories, setAllCategories] = useState([]);
  const fetchCategories = async () => {
    try {
      setIsLoading(true);
      const response = await fetch(process.env.REACT_APP_HOTE + "/liste-categories/");
      if (response.ok) {
        const data = await response.json();
        setAllCategories(data);
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des categories:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Défilement automatique des camions FIFO (entrants)
  useEffect(() => {
    let intervalFIFO;

    if (camions.length > 0 && !searchTerm && !isPaused) {
      const totalPages = Math.ceil(camions.length / nbParPageFIFO);

      if (totalPages > 1) {
        intervalFIFO = setInterval(() => {
          setCurrentPageFIFO((prev) => (prev + 1) % totalPages);
        }, dureeAffichageFIFO);
      }
    }

    return () => {
      if (intervalFIFO) clearInterval(intervalFIFO);
    };
  }, [camions, nbParPageFIFO, dureeAffichageFIFO, searchTerm, isPaused]);

  // Défilement automatique des camions sortants
  useEffect(() => {
    if (camionsSortants.length > 0 && !searchTerm && !isPaused) {
      const totalPages = Math.ceil(camionsSortants.length / nbParPageSortants);
      let intervalSortants;

      if (totalPages > 1) {
        intervalSortants = setInterval(() => {
          setCurrentPageSortants((prev) => (prev + 1) % totalPages);
        }, dureeAffichageSortants);
      }

      return () => clearInterval(intervalSortants);
    }
  }, [
    camionsSortants.length,
    nbParPageSortants,
    dureeAffichageSortants,
    searchTerm, isPaused
  ]);

  // Filtrer les camions basé sur le terme de recherche
  const filteredCamions = camions.filter(
    (camion) =>
      (camion.tete?.toString().toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
      (camion.queue?.toString().toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
      (camion.immatriculation?.toString().toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
      (camion.date_creation?.toString().toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
      (camion.charge_utile?.toString().toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
      (camion.type_camion?.toString().toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
      (camion.ordre?.toString().toLowerCase() || "").includes(searchTerm.toLowerCase())
  );

  const filteredCamionsSortants = camionsSortants.filter(
    (camion) =>
      (camion.tete__numero_immatriculation
        ?.toString().toLowerCase() || "")
        .includes(searchTerm.toLowerCase()) ||
      (camion.queue__numero_immatriculation
        ?.toString().toLowerCase() || "")
        .includes(searchTerm.toLowerCase()) ||
      (camion.immatriculation?.toString().toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
      (camion.date_creation?.toString().toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
      (camion.charge_utile?.toString().toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
      (camion.type_camion?.toString().toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
      (camion.ordre?.toString().toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
      (camion.lot_ref?.toString().toLowerCase() || "").includes(searchTerm.toLowerCase())
  );

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPageFIFO(0);
    setCurrentPageSortants(0);
    setCurrentCategorieIndex(0);
  };

  const paginatedCamions = filteredCamions.slice(
    currentPageFIFO * nbParPageFIFO,
    (currentPageFIFO + 1) * nbParPageFIFO
  );

  const paginatedCamionsSortants = filteredCamionsSortants.slice(
    currentPageSortants * nbParPageSortants,
    (currentPageSortants + 1) * nbParPageSortants
  );

  // Récupération des paramètres depuis le backend
  const fetchParametres = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_HOTE}/info-parametres-notifications/`
      );
      if (!response.ok)
        throw new Error("Erreur lors de la récupération des paramètres");
      const result = await response.json();
      if (result.success && result.data) {
        setItemsPerPage(result.data.nombre_elements_par_page || 5);
        setPageDuration(result.data.duree_affichage_page || 5);
      }
    } catch (error) {
      console.error("Erreur lors du fetch des paramètres :", error);
    }
  };

  // // Récupération des camions entrants
  // const fetchCamionsNationaux = async () => {
  //   try {
  //     setIsLoading(true);
  //     const response = await fetch(
  //       `${process.env.REACT_APP_HOTE}/liste-camions-ecran/${parc_ref}/?type_parc=national&tous=true`
  //     );
  //     const data = await response.json();

  //     const camionsTries = (data.camions || []).sort(
  //       (a, b) => a.ordre - b.ordre
  //     );

  //     const camionsAvecRang = camionsTries.map((camion, index) => ({
  //       ...camion,
  //       rang: index + 1,
  //     }));

  //     setCamions(camionsAvecRang);
  //   } catch (error) {
  //     console.error("Erreur réseau:", error);
  //     setCamions([]);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  // // Récupération des camions sortants
  // const fetchCamionsSortantsNationaux = async () => {
  //   try {
  //     setIsLoading(true);
  //     const response = await fetch(
  //       `${process.env.REACT_APP_HOTE}/liste-camions-sortants-ecran/${parc_ref}/`
  //     );
  //     const data = await response.json();

  //     // Ajouter le rang aux camions sortants
  //     const camionsAvecRang = (data.camions || []).map((camion, index) => ({
  //       ...camion,
  //       rang: index + 1
  //     }));

  //     // setCamionsSortants(data.camions || []);
  //     setCamionsSortants(camionsAvecRang);

  //   } catch (error) {
  //     console.error("Erreur réseau:", error);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  // Formatage de date
  const formatDate = (datetime) => {
    if (!datetime) return "";
    const date = new Date(datetime);
    return date.toLocaleDateString("fr-FR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  useEffect(() => {
  if (!parc_ref) return;

  const evtSource = new EventSource(`${process.env.REACT_APP_HOTE}/camions-stream/${parc_ref}/`);

  evtSource.addEventListener("entrants", e => {
    const data = JSON.parse(e.data);
    console.log("Camions entrants mis à jour :", data);
    setCamions(data);
  });

  evtSource.addEventListener("sortants", e => {
    const data = JSON.parse(e.data);
    console.log("🚚 Camions sortants mis à jour :", data);
    setCamionsSortants(data);
  });

  evtSource.onerror = (err) => {
    console.error("⚠️ Erreur SSE :", err);
    evtSource.close();
  };

  return () => evtSource.close();
}, [parc_ref]);


  useEffect(() => {
    fetchParametres();

    const intervalId = setInterval(fetchParametres, dureeAffichageFIFO);

    return () => clearInterval(intervalId);
  }, []);

  // Composant de carte pour entrants
  const CamionEntrantCard = ({ camion, index, isMobile, isTablet }) => (
    <motion.div
      key={`${camion.id || index}-${currentPageFIFO}`}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.3 }}
      style={{
        padding: "8px 10px",
        marginBottom: "8px",
        backgroundColor: "#fff",
        borderRadius: "8px",
        boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
        borderLeft: "3px solid #3498db",
        maxWidth: "400px",  // largeur max
        fontSize: "0.8rem",
        width: "100%",       // occupe toute la largeur du conteneur
        boxSizing: "border-box",
      }}
    >
      {/* Ligne 1 - Rang + Immatriculation + Date */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "10px",  // espace régulier entre badges
          marginBottom: "8px"
        }}
      >
        {/* Rang */}
        <div
          style={{
            width: "auto",
            padding: "0 4px",
            height: "22px",
            backgroundColor: "#f1f5f9",
            borderRadius: "4px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: "600",
            fontSize: "0.75rem",
            flexShrink: 0,
          }}
        >
          {camion.ordre} 
        </div>

        {/* Immatriculation */}
        <div
          style={{
            fontWeight: "500",
            flex: isTablet ? "0 1 auto" : 1,
            minWidth: isMobile ? "calc(100% - 28px)" : "140px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {/* {camion.tete || camion.immatriculation}
          {camion.queue && (
            <span style={{ color: "#95a5a6" }}> + {camion.queue}</span>
          )} */}

          {camion.atellage === '1'
            ? `${camion.tete} + ${camion.queue}`
            : camion.immatriculation || 'Non spécifié'}
        </div>

        {/* Date */}
        <div
          style={{
            color: "#7f8c8d",
            flexShrink: 0,
            ...(isMobile && { order: 3, width: "100%" }),
            ...(isTablet && { marginLeft: "auto" }),
            fontSize: "0.75rem",
          }}
        >
          <span>Entré: </span>
          <span>{camion.date_creation ? formatDate(camion.date_creation) : "-"}</span>
        </div>
      </div>

      {/* Ligne 2 - Charge utile, Parc */}
      <div style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "10px",  // espace régulier entre badges
        marginBottom: "8px"
      }}>
        <span style={{
          fontSize: "11px",
          fontWeight: "600",
          color: "#3b82f6",
          padding: "4px 8px",
          backgroundColor: "#eff6ff",
          display: "flex",
          alignItems: "center",
          gap: "4px",
          borderRadius: "10px"
        }}>
          <FaWeightHanging size={12} color="#f59e0b" />
          Charge utile: {camion.charge_utile || "-"} kg
        </span>

        <span style={{
          fontSize: "11px",
          fontWeight: "600",
          padding: "4px 8px",
          backgroundColor: "#eff6ff",
          borderRadius: "10px",
          display: "flex",
          alignItems: "center",
          gap: "4px",
          color: "#92400e",
        }}>
          <BsCarFront size={12} color="#ef4444" />
          {camion.type_camion || "-"}
        </span>
      </div>
    </motion.div>
  );

  // Composant de carte pour sortants
  const CamionSortantCard = ({ camion, index, isMobile, isTablet }) => (
    <motion.div
      key={`${camion.id || index}-${currentPageSortants}`}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.3 }}
      style={{
        padding: "8px 10px",
        marginBottom: "8px",
        backgroundColor: "#fff",
        borderRadius: "8px",
        boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
        borderLeft: "3px solid #e74c3c",
        maxWidth: "400px",
        width: "100%",
        boxSizing: "border-box",
        fontSize: "0.8rem",
      }}
    >
      {/* Ligne 1 - Rang + Immatriculation + Date */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "10px",  // espace régulier entre badges
          marginBottom: "8px"
        }}
      >
        {/* Rang */}
        <div
          style={{
            width: "auto",
            padding: "0 4px",
            height: "22px",
            backgroundColor: "#f1f5f9",
            borderRadius: "4px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: "600",
            fontSize: "0.75rem",
            flexShrink: 0,
          }}
        >
          {camion.ordre || index + 1 + currentPageSortants * nbParPageSortants} 
        </div>

        {/* Immatriculation */}
        <div
          style={{
            fontWeight: "500",
            flex: isTablet ? "0 1 auto" : 1,
            minWidth: isMobile ? "calc(100% - 28px)" : "140px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {camion.atellage === '1'
            ? `${camion.tete} + ${camion.queue}`
            : camion.immatriculation || 'Non spécifié'}
        </div>

        {/* Date */}
        {/* <div
          style={{
            color: "#7f8c8d",
            flexShrink: 0,
            ...(isMobile && { order: 3, width: "100%" }),
            ...(isTablet && { marginLeft: "auto" }),
            fontSize: "0.75rem",
          }}
        >
          <span>Sorti: </span>
          <span>
            {camion.date_sortie_reele
              ? formatDate(camion.date_sortie_reele)
              : "-"}
          </span>
        </div> */}
      </div>

      {/* Ligne 2 - Charge utile, Parc */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "10px",      // espace régulier entre badges
          marginBottom: "8px"
        }}
      >
        {/* Charge utile */}
        <span
          style={{
            fontSize: "11px",
            fontWeight: "600",
            padding: "4px 8px",
            backgroundColor: "#eff6ff",
            borderRadius: "10px",
            display: "flex",
            alignItems: "center",
            gap: "4px",
            color: "#3b82f6",
          }}
        >
          <FaWeightHanging size={12} color="#f59e0b" />
          Charge utile: {camion.charge_utile || "-"} kg
        </span>

        {/* Type camion */}
        <span
          style={{
            fontSize: "11px",
            fontWeight: "600",
            padding: "4px 8px",
            backgroundColor: "#eff6ff",
            borderRadius: "10px",
            display: "flex",
            alignItems: "center",
            gap: "4px",
            color: "#92400e",
          }}
        >
          <BsCarFront size={12} color="#ef4444" />
          {camion.type_camion || "-"}
        </span>
      </div>

      {/* Ligne 3 - Type, Lot */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "10px",
          marginBottom: "8px"
        }}
      >
        {/* Lot */}
        <span
          style={{
            fontSize: "11px",
            fontWeight: "600",
            padding: "4px 8px",
            backgroundColor: "#eff6ff",
            borderRadius: "10px",
            display: "flex",
            alignItems: "center",
            gap: "4px",
            color: "#7f8c8d",
          }}
        >
          <FaBoxOpen size={12} color="#10b981" />
          Lot: {camion.lot_ref || "-"}
        </span>
      </div>

    </motion.div>
  );

  // Initialisation au montage
  useEffect(() => {
    fetchParametres();
    // fetchCamionsNationaux();
    // fetchCamionsSortantsNationaux();
    fetchCategories();
    fetchParcs();
  }, []);

  // Trouver le parc correspondant à parc_ref
  const parc = parcs.find((p) => p.ref_parc === parc_ref);

  // Détection de la taille de l'écran
  // useEffect(() => {
  //   const checkScreenSize = () => {
  //     const width = window.innerWidth;
  //     setIsMobileView(width < 992); // Tablette et smartphone
  //   };

  //   checkScreenSize();
  //   window.addEventListener('resize', checkScreenSize);
  //   return () => window.removeEventListener('resize', checkScreenSize);
  // }, []);

  const isMobile = useMediaQuery({ maxWidth: 767 });
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 991 });
  const isDesktop = useMediaQuery({ minWidth: 992 });

  // Calcul de isMobileView pour la compatibilité avec le code existant
  const isMobileView = isMobile || isTablet;

  // Regrouper camions entrants et sortants par nom_categorie
  const categories = Array.from(
    new Set([
      ...camions.map((c) => c.nom_categorie),
      ...camionsSortants.map((c) => c.nom_categorie),
    ])
  );

  // Déterminer si on est en mode recherche
  const isSearching = searchTerm.trim() !== "";

  // Regrouper camions par catégorie
  // const camionsParCategorie = allCategories.filter((cat) =>
  //   selectedCategorie ? cat.nom_categorie === selectedCategorie : true
  // ).map((cat) => {
  //   const entrants = filteredCamions.filter(c => c.nom_categorie === cat.nom_categorie);
  //   const sortants = filteredCamionsSortants.filter(c => c.nom_categorie === cat.nom_categorie);

  //   return {
  //     categorie: cat.nom_categorie,
  //     entrants,
  //     sortants,
  //   };
  // })
  //   // Si on est en recherche, ne garder que les catégories avec au moins un camion correspondant
  //   .filter(cat => !isSearching || cat.entrants.length > 0 || cat.sortants.length > 0);

  const camionsParCategorie = allCategories
    .filter((cat) =>
      selectedCategorie ? cat.nom_categorie === selectedCategorie : true
    )
    .map((cat) => {
      const entrants = filteredCamions.filter(
        (c) => c.nom_categorie === cat.nom_categorie
      );
      const sortants = filteredCamionsSortants.filter(
        (c) => c.nom_categorie === cat.nom_categorie
      );

      return {
        categorie: cat.nom_categorie,
        entrants,
        sortants,
      };
    })
    // On garde les catégories avec résultats si on recherche
    .filter(
      (cat) =>
        !isSearching || cat.entrants.length > 0 || cat.sortants.length > 0
    )
    // 🔥 Tri : catégories avec données d’abord
    .sort((a, b) => {
      const aHasData = a.entrants.length > 0 || a.sortants.length > 0 ? 1 : 0;
      const bHasData = b.entrants.length > 0 || b.sortants.length > 0 ? 1 : 0;
      return bHasData - aHasData; // celles avec données en premier
    });



  const dureeAffichageCategories = 5000; // 30s par exemple

  const [currentCategorieIndex, setCurrentCategorieIndex] = useState(0);

  useEffect(() => {
    console.log("Camions entrants:", camions);
    console.log("Camions sortants:", camionsSortants);
    console.log("Toutes les catégories:", allCategories);
  }, [camions, camionsSortants, allCategories]);

  useEffect(() => {
    if (camionsParCategorie.length > 2 && !searchTerm && !isPaused && !selectedCategorie) {
      const interval = setInterval(() => {
        setCurrentCategorieIndex(
          (prev) => (prev + 2) % camionsParCategorie.length
        );
      }, dureeAffichageCategories); // On réutilise ta durée

      return () => clearInterval(interval);
    }
  }, [camionsParCategorie.length, dureeAffichageCategories, searchTerm, isPaused, selectedCategorie]);

  // Récupérer les deux catégories actives à afficher
  const categoriesActive = camionsParCategorie.slice(
    currentCategorieIndex,
    currentCategorieIndex + 2
  );

  // Si on atteint la fin du tableau, on peut compléter avec les premières catégories pour boucler
  if (categoriesActive.length < 2 && camionsParCategorie.length > 1) {
    categoriesActive.push(...camionsParCategorie.slice(0, 2 - categoriesActive.length));
  }


  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
        padding: "20px",
        display: "flex",
        flexDirection: "column"
      }}

    >
      {/* En-tête principal */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        style={{
          textAlign: "center",
          marginBottom: "30px"
        }}
      >
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "12px" }}>
          <FaShip size={28} color="#3b82f6" />
          <h1 style={{
            fontSize: "32px",
            fontWeight: "700",
            color: "#1e293b",
            letterSpacing: "-0.02em",
            margin: 0
          }}>
            {/* {parc.nom_parc} */}
            {parc ? parc.nom_parc : "Parc introuvable"}
          </h1>
        </div>
        <p style={{ color: "#64748b", fontSize: "14px", marginTop: "8px" }}>
          Affichage en temps réel des camions par catégorie
        </p>
      </motion.div>
      {/* Barre de recherche (visible seulement sur mobile/tablette) */}
      {(isMobile || isTablet) && (
        <div
          style={{
            margin: "0 0 20px 0",
            padding: "0 10px",
            width: "100%",
            boxSizing: "border-box",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "stretch",
              gap: "10px",
              width: "100%",
              maxWidth: "600px",
              margin: "0 auto",
            }}
          >
            {/* Champ recherche */}
            <div
              style={{
                position: "relative",
                width: "100%",
              }}
            >
              <input
                type="text"
                placeholder="Rechercher immatriculation..."
                value={searchTerm}
                onChange={handleSearchChange}
                onFocus={() => {
                  if (searchTerm) {
                    setCurrentPageFIFO(0);
                    setCurrentPageSortants(0);
                  }
                }}
                style={{
                  width: "100%",
                  padding: "12px 15px",
                  borderRadius: "6px",
                  border: "1px solid #3498db",
                  fontSize: "14px",
                  fontFamily: "inherit",
                  boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                }}
              />
              {searchTerm && (
                <button
                  onClick={() => setSearchTerm("")}
                  style={{
                    position: "absolute",
                    right: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    background: "transparent",
                    border: "none",
                    fontSize: "18px",
                    cursor: "pointer",
                    color: "#7f8c8d",
                  }}
                >
                  ×
                </button>
              )}
            </div>

            {/* Filtre catégories */}
            <select
              value={selectedCategorie || ""}
              onChange={(e) => setSelectedCategorie(e.target.value || null)}
              style={{
                width: "100%",
                padding: "12px 15px",
                borderRadius: "6px",
                border: "1px solid #3498db",
                fontSize: "14px",
                fontFamily: "inherit",
              }}
            >
              <option value="">Toutes les catégories</option>
              {allCategories.map((parc) => (
                <option key={parc.ref_parc} value={parc.nom_categorie}>
                  {parc.nom_categorie}
                </option>
              ))}
            </select>
          </div>
        </div>
      )}


      <div
        style={{
          display: "grid",
          gridTemplateColumns: isMobileView ? "1fr" : "1fr 1fr", // 2 catégories max par ligne
          gap: "20px",
          marginBottom: "20px",
          justifyContent: "center"
        }}
      >
        {categoriesActive.map((categorie, idx) => (
          <div
            key={categorie.categorie || idx}

            style={{
              background: "#fff",
              borderRadius: "8px",
              padding: "12px",
            }}
            // onMouseEnter={() => setIsPaused(true)}
            // onMouseLeave={() => setIsPaused(false)}
            onTouchStart={() => setIsPaused(true)}
            onTouchEnd={() => setIsPaused(false)}
          >
            {/* Titre Catégorie */}
            <div
              style={{
                textAlign: "center",
                marginBottom: "20px",
                padding: "20px",
                backgroundColor: "#3b82f6",
                color: "white",
                borderRadius: "12px",
                margin: "-12px -12px 12px -12px",
                zIndex: 10,
                position: "relative"
              }}
            >
              <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>
                <FaLayerGroup size={16} />
                <span style={{ fontSize: "16px", fontWeight: "600" }}>
                  {categorie.categorie}
                </span>
              </div>
              {/* Catégorie : {categorie.categorie} */}

            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr", // Entrants & Sortants côte à côte
                gap: "12px",
                justifyContent: "center"
              }}
            >
              {/* Colonne Entrants */}
              <div>
                <div
                  style={{
                    padding: "8px 12px",
                    backgroundColor: "#f8f9fa",
                    borderBottom: "1px solid #e9ecef",
                  }}
                >
                  <h4 style={{ margin: 0 }}>Camions entrants</h4>
                </div>
                <div style={{ padding: "8px" }}>
                  <AnimatePresence mode="wait">
                    {categorie.entrants.length > 0 ? (
                      categorie.entrants
                        .slice(currentPageFIFO * nbParPageFIFO, (currentPageFIFO + 1) * nbParPageFIFO)
                        .map((camion, index) => (
                          <CamionEntrantCard
                            key={`${camion.id}-${currentPageFIFO}`}
                            camion={camion}
                            index={index}
                            isMobile={isMobile}
                            isTablet={isTablet}
                          />
                        ))
                    ) : (
                      <div style={{ padding: "8px", color: "#64748b", fontStyle: "italic" }}>
                        Aucun camion entrant
                      </div>
                    )}
                  </AnimatePresence>
                </div>
              </div>

              {/* Colonne Sortants */}
              <div>
                <div
                  style={{
                    padding: "8px 12px",
                    backgroundColor: "#f8f9fa",
                    borderBottom: "1px solid #e9ecef",
                  }}
                >
                  <h4 style={{ margin: 0 }}>Camions sortants</h4>
                </div>
                <div style={{ padding: "8px" }}>
                  <AnimatePresence mode="wait">
                    {categorie.sortants.length > 0 ? (
                      categorie.sortants
                        .slice(currentPageSortants * nbParPageSortants, (currentPageSortants + 1) * nbParPageSortants)
                        .map((camion, index) => (
                          <CamionSortantCard
                            key={`${camion.id}-${currentPageSortants}`}
                            camion={camion}
                            index={index}
                            isMobile={isMobile}
                            isTablet={isTablet}
                          />
                        ))
                    ) : (
                      <div style={{ padding: "8px", color: "#64748b", fontStyle: "italic" }}>
                        Aucun camion sortant
                      </div>
                    )}
                  </AnimatePresence>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

    </div>
  );
};

export default Liste_nationaux;
